import { render, staticRenderFns } from "./AppLauncherWarning.vue?vue&type=template&id=135573ca&scoped=true"
import script from "./AppLauncherWarning.vue?vue&type=script&lang=ts"
export * from "./AppLauncherWarning.vue?vue&type=script&lang=ts"
import style0 from "./AppLauncherWarning.vue?vue&type=style&index=0&id=135573ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_css-loader@7.1.2_webpack@5.104.1__ejs@3.1.10_hand_w4ihhltspsauj6xsmipdmrbgw4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135573ca",
  null
  
)

export default component.exports